import { BaseDataTransferObject } from '../../../shared/models/base-data-transfer-object';
import { Client, ClientWithExtras } from '../../../shared/models/order-entry/client';
import { Patient, PatientEditable, PatientSearchWithoutCollections } from '../../../shared/models/order-entry/patient';
import { Physician } from '../../../shared/models/order-entry/physician';
import { Room, RoomWithUnit } from '../../../shared/models/order-entry/room';
import { CancellationReason } from './cancellation-reason';
import { CollectionSite } from './collection-site';
import { OrderSearchResult } from './results';

export enum OrderStatus {
    None = 0,
    Pending = 1,
    Unreleased = 2,
    PartiallyReleased = 4,
    Partial = 8,
    Final = 16, // 0x00000010
    Canceled = 32, // 0x00000020
    Preliminary = 64, // 0x00000040
    All = 0x0000007F
}

export enum OrderPriority {
  Preoperatory = 2,
  Routine = 4,
  Stat = 8,
  Rush = 16,
  None = 32
}

export class WebOrder extends BaseDataTransferObject {
    public codeValue?: string;
    public orderDate?: Date;
    public orderCollectionDate?: Date;
    public status?: OrderStatus;
    public hasAlert?: boolean;
    public criticalResults?: boolean;
    public criticalToxResults?: boolean;
    public criticalMicResults?: boolean;
    public patientLastName?: string;
    public patientFirstName?: string;
    public patientDoB?: Date;
    public patientRoom?: string;
    public patientBed?: string;
    public client?: string;
    public onlineAckDateTime?: Date;
    public onlineAckUser?: string;
    public testNames?: string;
    public hasMissingInfo?: boolean;
    public orderResults?: OrderSearchResult[];
}

export class Order extends BaseDataTransferObject {
    public codeValue?: string;
    public orderDate?: Date;
    public collectionDate?: Date;
    public status?: OrderStatus;
    public hasAlert: boolean = false;
    public alert?: string;
    public patientLastName?: string;
    public patientFirstName?: string;
    public patient?: PatientSearchWithoutCollections;
    public physician?: Physician;
    public patientRoom?: RoomWithUnit;
    public patientClient: ClientWithExtras = new ClientWithExtras();
    public onlineAckDateTime?: Date;
    public onlineAckUser?: string;
    public receivedDate?: Date;
    public reported ?: Date;
    public reportComment: string = '';
    public cancellationReasons?: CancellationReason[];
    public collectionSites?: CollectionSite[];
    public hasToxicologyUnexpectedPositive: boolean = false;
}
